export const UI_SET_ACTIVE_SECTION = 'UI_SET_ACTIVE_SECTION';
export const UI_SET_ACTIVE_TITLE = 'UI_SET_ACTIVE_TITLE';
export const UI_SET_FULLHEIGHT = 'UI_SET_FULLHEIGHT';
export const UI_SET_MENU_OPEN = 'UI_SET_MENU_OPEN';
export const UI_SET_SHARE_WIDGET_OPEN = 'UI_SET_SHARE_WIDGET_OPEN';
export const UI_SET_FRAME_CONTEXT = 'UI_SET_FRAME_CONTEXT';
export const UI_START_ROUTE_TRANSITION = 'UI_START_ROUTE_TRANSITION';
export const UI_END_ROUTE_TRANSITION = 'UI_END_ROUTE_TRANSITION';

export const setActiveSection = slug => ({
  type: UI_SET_ACTIVE_SECTION,
  payload: slug,
});

export const setActiveTitle = uid => ({
  type: UI_SET_ACTIVE_TITLE,
  payload: uid,
});

export const setFullHeight = bool => ({
  type: UI_SET_FULLHEIGHT,
  payload: bool,
});

export const setMenuOpen = bool => ({
  type: UI_SET_MENU_OPEN,
  payload: bool,
});

export const setShareWidgetOpen = bool => ({
  type: UI_SET_SHARE_WIDGET_OPEN,
  payload: bool,
});

export const setFrameContext = () => {
  let isEmbedded = 'no';
  let parentUrl = '';
  let embeddedUrl = '';

  try {
    isEmbedded = window.self !== window.top ? 'yes' : 'no';
  } catch (e) {
    isEmbedded = 'yes';
  }

  if (isEmbedded === 'yes') {
    parentUrl = document.referrer;
    embeddedUrl = window.location.href;
  }

  return {
    type: UI_SET_FRAME_CONTEXT,
    payload: { isEmbedded, parentUrl, embeddedUrl },
  };
};

export const startRouteTransition = () => ({
  type: UI_START_ROUTE_TRANSITION,
});

export const endRouteTransition = () => ({
  type: UI_END_ROUTE_TRANSITION,
});



// WEBPACK FOOTER //
// ./src/actions/uiActions.js